import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Home from './pages/Home'
import Tools from './pages/Tools'
import Components from './pages/Components'
import './styles/App.css'

function App() {
  return (
    <Router>
      <div className="app">
        <header className="app-header">
          <nav className="nav">
            <Link to="/" className="nav-logo">
              All In One
            </Link>
            <div className="nav-links">
              <Link to="/" className="nav-link">首页</Link>
              <Link to="/tools" className="nav-link">工具</Link>
              <Link to="/components" className="nav-link">组件</Link>
            </div>
          </nav>
        </header>
        
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/components" element={<Components />} />
          </Routes>
        </main>
        
        <footer className="app-footer">
          <p>&copy; 2026 All in One. 个人常用 Web 工具集</p>
        </footer>
      </div>
    </Router>
  )
}

export default App